<div class="dialog-form">
    <form [formGroup]="licenseForm">
      
        <p-fieldset legend="Habilitação" style="margin-bottom: 20px;">
          <div class="form-group flex-row-between">
            <div class="form-control" style="width: 30%;">
              <label for="register">Número do Registro *</label>
              <input pInputText formControlName="register" placeholder="Digite o número do registro" />
              <small *ngIf="submitted && licenseForm.get('register')?.errors?.required" class="p-error block">
                Registro obrigatório
              </small>
            </div>
  
            <div class="form-control" style="width: 30%;">
              <label for="expiration">Data de Validade *</label>
              <p-calendar formControlName="expiration" [showIcon]="true" dateFormat="dd/mm/yy"
                [monthNavigator]="true" [yearNavigator]="true"></p-calendar>
              <small *ngIf="submitted && licenseForm.get('expiration')?.errors?.required" class="p-error block">
                Validade obrigatória
              </small>
            </div>
  
            <div class="form-control" style="width: 30%;">
              <label for="typeLicense">Tipo de Habilitação *</label>
              <p-dropdown [options]="licenseTypes" formControlName="typeLicense" appendTo="body"
                placeholder="Selecione o tipo"></p-dropdown>
              <small *ngIf="submitted && licenseForm.get('typeLicense')?.errors?.required" class="p-error block">
                Tipo obrigatório
              </small>
            </div>
          </div>
  
          <div class="form-group flex-row-between">
            <div class="form-control" style="width: 30%;">
              <label for="country">País de Emissão *</label>
              <p-dropdown [options]="countries" formControlName="country" appendTo="body"
                (onChange)="onCountryChange()"></p-dropdown>
              <small *ngIf="submitted && licenseForm.get('country')?.errors?.required" class="p-error block">
                País obrigatório
              </small>
            </div>
  
            <div class="form-control" style="width: 30%;">
              <label for="state">Estado/Província *</label>
              <p-dropdown *ngIf="isBrazilianLicense; else stateInput" [options]="states" formControlName="state"
                appendTo="body" (onChange)="loadCities()"></p-dropdown>
              <ng-template #stateInput>
                <input pInputText formControlName="state" placeholder="Digite o estado" />
              </ng-template>
              <small *ngIf="submitted && licenseForm.get('state')?.errors?.required" class="p-error block">
                Estado obrigatório
              </small>
            </div>
  
            <div class="form-control" style="width: 30%;">
              <label for="city">Cidade *</label>
              <p-autoComplete formControlName="city" [suggestions]="filteredCities"
                (completeMethod)="filterCities($event)"></p-autoComplete>
              <small *ngIf="submitted && licenseForm.get('city')?.errors?.required" class="p-error block">
                Cidade obrigatória
              </small>
            </div>
          </div>
        </p-fieldset>
        <div style="height: 20px; margin-bottom: 0px;"></div>

        <p-fieldset legend="Arquivo Anexado" style="margin-top: 20px; width: 100%;">
          <div class="form-group" style="width: 100%;">
            <div *ngIf="licenseForm.get('fileUrl').value" class="file-preview">
              <span class="file-name">{{ licenseForm.get('fileUrl').value | extractFilename }}</span>
              <div class="flex justify-content-center gap-2">
                <button 
                  pButton 
                  type="button" 
                  icon="pi pi-eye" 
                  class="p-button-rounded p-button-text mr-2"
                  (click)="viewFile(fileLicense)"
                  *ngIf="licenseForm.get('fileUrl').value">
                </button>
                <button pButton icon="pi pi-trash" class="p-button-rounded p-button-danger p-button-sm"
                  (click)="removeFile()"></button>
              </div>
            </div>
        
            <div class="mt-3">
              <app-licence-upload
                [path]="fileUploadUrl"
                [title]="licenseForm.get('fileUrl').value ? 'Foto da Licença' : 'Adicionar Licença'"
                (finishEvent)="onUploadFinish($event)">
              </app-licence-upload>
            </div>
          </div>
        </p-fieldset>
  
        <div class="buttons mt-4">
          <p-button class="save-button" 
                    label="Salvar" 
                    type="button" 
                    (click)="save()"
                    [disabled]="licenseForm.invalid && submitted">
          </p-button>
        </div>
      
    </form>
  </div>